<p-table
  #pt
  [value]="audits"
  [paginator]="true"
  [rows]="25"
  [rowsPerPageOptions]="[25,100,200]"
  showCurrentPageReport="true"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records"
  [responsive]="true"
  sortMode="multiple"
  selectionMode="single"
  dataKey="childId"
  [loading]="loading"
  [autoLayout]="true"
  [globalFilterFields]="['id','commitDate','author','label','childType','childId','propertyName','left','right']">
  <ng-template pTemplate="caption">
    <i class="fa fa-search" style="margin:4px 4px 0 0;"></i>
    <input type="text" pInputText placeholder="Search" (input)="pt.filterGlobal($event.target.value, 'contains')" style="width:auto;">
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      }
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-row>
    <tr>
      @for (col of columns; track col) {
        <td>
          @switch (col.field) {
            @case ('id') {
              <span>{{row['id']}}</span>
            }
            @case ('commitDate') {
              <span>{{row['commitDate']}}</span>
            }
            @case ('author') {
              <span>{{row['author']}}</span>
            }
            @case ('label') {
              <span>{{row['label']}}</span>
            }
            @case ('childType') {
              <span>{{row['childType']}}</span>
            }
            @case ('propertyName') {
              <span>{{row['propertyName']}}</span>
            }
            @case ('left') {
              <span>{{row['left']}}</span>
            }
            @case ('right') {
              <span>{{row['right']}}</span>
            }
            @case ('childId') {
              <span>{{row['childId']}}</span>
            }
          }
        </td>
      }
    </tr>
  </ng-template>
</p-table>


